<template>
  <v-list-group :data-test-menu="item.id" v-model="open" no-action>
    <template v-slot:activator>
      <v-list-item-icon>
        <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title
          class="menu-item"
          v-text="item.title"
        ></v-list-item-title>
      </v-list-item-content>
    </template>
    <default-menu-item
      :data-test-menu="subItem.id"
      v-on="$listeners"
      :key="subItem.id"
      :item="subItem"
      v-for="subItem in item.children"
    />
  </v-list-group>
</template>

<script>
import DefaultMenuItem from './Default';
export default {
  name: 'NestedMenuItem',
  components: {
    DefaultMenuItem
  },
  props: {
    level: {
      type: Number,
      default: 0
    },
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    open: false
  }),
  watch: {
    open() {
      this.$emit('action', {
        action: this.item.action,
        open: this.open,
        id: this.item.id
      });
    }
  }
};
</script>
